/**
* DevExpress HTML/JS Reporting (viewer\mobile\internal\_paginator.js)
* Version:  22.2.6
* Build date: Apr 17, 2023
* Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { Disposable, getLocalization } from '@devexpress/analytics-core/analytics-utils';
import * as ko from 'knockout';
import * as $ from 'jquery';
export class MobilePaginator extends Disposable {
    constructor(reportPreview, gallery) {
        super();
        this.visible = ko.observable(false).extend({ notify: 'always' });
        this._disposables.push(this.text = ko.computed(() => {
            setTimeout(() => { this.visible(true); }, 1);
            if (reportPreview.pageIndex() === -1) {
                return getLocalization('0 pages', 'ASPxReportsStringId.WebDocumentViewer_0Pages');
            }
            else {
                var ofText = getLocalization('of', 'ASPxReportsStringId.ToolBarItemText_OfLabel');
                var pageText = getLocalization('Page', 'ASPxReportsStringId.ToolBarItemText_PageLabel');
                return pageText + ' ' + gallery.currentBlockText() + ' ' + ofText + ' ' + reportPreview.pages().length;
            }
        }));
    }
}
ko.bindingHandlers['dxrdMobilePaginator'] = {
    init: function (element, valueAccessor) {
        var values = valueAccessor();
        var $element = $.fn.constructor(element);
        var timeoutId = null;
        var hideAnimationTimeoutId = null;
        values.visible.subscribe((newVal) => {
            if (newVal) {
                $element.removeClass('dxrdp-hide').addClass('dxrdp-show');
                timeoutId && clearTimeout(timeoutId);
                timeoutId = setTimeout(() => { values.visible(false); }, 2000);
            }
            else {
                $element.removeClass('dxrdp-show').addClass('dxrdp-hide');
                hideAnimationTimeoutId && clearTimeout(hideAnimationTimeoutId);
                hideAnimationTimeoutId = setTimeout(() => {
                    $element.removeClass('dxrdp-hide');
                }, 500);
            }
        });
    }
};
